@if (_isLoading) {
  <div class="explore-initial-loading">
    <mat-spinner diameter="32"></mat-spinner>
  </div>
}

@if (!_isLoading && _elements.length > 0) {
  <div class="explore-carousel-wrapper">
    <div class="explore-header">
      <ddc-text-gradient
        [_icon]="'local_fire_department'"
        [_text]="'Dictionaries for you'"
        [_type]="'1'"
      ></ddc-text-gradient>
    </div>

    <div class="carousel-container">
      <!-- Left arrow -->
      <button class="carousel-arrow arrow-left" [disabled]="_currentIndex === 0" (click)="onPrevious()">
        <mat-icon>chevron_left</mat-icon>
      </button>

      <!-- Cards track -->
      <div class="carousel-track">
        <div class="cards-slider" [style.transform]="'translateX(' + -_currentIndex * 80 + '%)'">
          @for (elem of _elements; track elem.id; let i = $index) {
            <div class="card-wrapper">
              <div
                class="explore-card"
                style="cursor: pointer"
                [class.active]="i === _currentIndex"
                (click)="goToDictionary(elem)"
              >
                <!-- Owner info -->
                <div class="card-owner" style="cursor: pointer" (click)="goToUser(elem.owner.username, $event)">
                  <img
                    class="owner-avatar"
                    alt="Profile"
                    [src]="getProfilePic(elem)"
                    (error)="handleImageError($event)"
                  />
                  <div class="owner-details">
                    <span class="owner-username">
                      {{ elem.owner.username }}
                      @if (elem.owner.is_verified) {
                        <mat-icon class="verified-icon">verified</mat-icon>
                      }
                    </span>
                  </div>
                </div>

                <!-- Dictionary title -->
                <div class="card-title">{{ elem.title }}</div>

                <!-- Stats -->
                <div class="card-stats">
                  <div class="stat">
                    <mat-icon class="stat-icon">fiber_manual_record</mat-icon>
                    <span class="stat-value">{{ elem.words_count }}</span>
                  </div>
                  <div class="stat-divider"></div>
                  <div class="stat">
                    <mat-icon class="stat-icon">fiber_smart_record</mat-icon>
                    <span class="stat-value">{{ elem.pairs_count }}</span>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>

        <!-- Fetching more overlay -->
        @if (_isFetchingMore) {
          <div class="fetching-more-overlay">
            <mat-spinner diameter="24"></mat-spinner>
          </div>
        }
      </div>

      <!-- Right arrow -->
      <button class="carousel-arrow arrow-right" [disabled]="_currentIndex >= _elements.length - 1" (click)="onNext()">
        <mat-icon>chevron_right</mat-icon>
      </button>
    </div>
  </div>
}
